<template>
  <form refs="freeSamples" class="form" novalidate @submit.prevent="validate">
    <div class="row">
      <div class="col">
        <h2 class="title">Request free samples (Veterinarians Only)</h2>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-paw" />
          <input
            id="patient_first_name"
            v-model="samples.patient_first_name"
            :class="{ error: $v.samples.patient_first_name.$error }"
            type="text"
            name="patient_first_name"
            placeholder="Patient First Name"
            required="required"
            class="input"
            @input="$v.samples.patient_first_name.$touch()"
          >
          <label
            v-if="
              $v.samples.patient_first_name.$error &&
                !$v.samples.patient_first_name.required
            "
            class="error"
            for="name"
          >This field is required.</label
          >
        </div>
      </div>
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-paw" />
          <input
            id="patient_last_name"
            v-model="samples.patient_last_name"
            :class="{ error: $v.samples.patient_last_name.$error }"
            type="text"
            name="patient_last_name"
            placeholder="Patient Last Name"
            required="required"
            class="input"
            @input="$v.samples.patient_last_name.$touch()"
          >
          <label
            v-if="
              $v.samples.patient_last_name.$error &&
                !$v.samples.patient_last_name.required
            "
            class="error"
            for="name"
          >This field is required.</label
          >
        </div>
      </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="input-wrap">
            <div class="icon icon-paw" />
            <input
              id="species"
              v-model="samples.species"
              type="text"
              name="species"
              placeholder="Species"
              required="required"
              :class="{ 'error': $v.samples.species.$error }"
              class="input LoNotSensitive"
              @input="$v.samples.species.$touch()"
            >
            <label
              v-if="$v.samples.species.$error && !$v.samples.species.required"
              class="error"
              for="name"
            >This field is required.</label>
          </div>
          </div>
          <div class="col">
          <div class="input-wrap">
            <div class="icon icon-paw" />
            <input
              id="breed"
              v-model="samples.breed"
              type="text"
              name="breed"
              placeholder="Breed"
              required="required"
              :class="{ 'error': $v.samples.breed.$error }"
              class="input LoNotSensitive"
              @input="$v.samples.breed.$touch()"
            >
            <label
              v-if="$v.samples.breed.$error && !$v.samples.breed.required"
              class="error"
              for="name"
            >This field is required.</label>
          </div>
          </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="input-wrap">
            <div class="icon icon-paw" />
            <input
              id="weight"
              v-model="samples.weight"
              type="text"
              name="weight"
              placeholder="Weight in lbs"
              required="required"
              :class="{ 'error': $v.samples.weight.$error }"
              class="input LoNotSensitive"
              @input="$v.samples.weight.$touch()"
            >
            <label
              v-if="$v.samples.weight.$error && !$v.samples.weight.required"
              class="error"
              for="name"
            >This field is required.</label>
          </div>
          </div>
          <div class="col">
          <div class="input-wrap">
            <div class="icon icon-paw" />
            <input
              id="age"
              v-model="samples.age"
              type="text"
              name="age"
              placeholder="Age/DOB"
              required="required"
              :class="{ 'error': $v.samples.age.$error }"
              class="input LoNotSensitive"
              @input="$v.samples.age.$touch()"
            >
            <label
              v-if="$v.samples.age.$error && !$v.samples.age.required"
              class="error"
              for="name"
            >This field is required.</label>
          </div>
          </div>
      </div>
      <div class="row">
        <div class="col">
        <div class="select-wrap">
          <div class="icon icon-paw" />
          <select v-model.trim="samples.sex" name="sex" class="select">
            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>
          <span v-if="!samples.sex" class="placeholder">Sex</span>
        </div>
        <label
              v-if="$v.samples.sex.$error && !$v.samples.sex.required"
              class="error"
              for="name"
            >This field is required.</label>
      </div>
      </div>
    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-paw" />
          <input
            id="clinic"
            v-model="samples.clinic"
            type="text"
            name="clinic"
            placeholder="Clinic"
            required="required"
            :class="{ 'error': $v.samples.clinic.$error }"
            class="input LoNotSensitive"
            @input="$v.samples.clinic.$touch()"
            >
            <label
              v-if="$v.samples.clinic.$error && !$v.samples.clinic.required"
              class="error"
              for="clinic"
            >This field is required.</label>
        </div>
      </div>
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-mail" />
          <input
            id="email"
            v-model="samples.email"
            :class="{ 'error': $v.samples.email.$error }"
            type="text"
            name="email"
            placeholder="Email (Required)"
            required="required"
            class="input LoNotSensitive"
            @input="$v.samples.email.$touch()"
          >
          <label
            v-if="$v.samples.email.$error && !$v.samples.email.required"
            class="error"
            for="email"
          >This field is required.</label>
          <label
            v-if="$v.samples.email.$error && !$v.samples.email.email"
            class="error"
            for="email"
          >Valid email is required.</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-user" />
          <input
            id="doctor"
            v-model="samples.doctor"
            type="text"
            name="doctor"
            placeholder="Doctor"
            required="required"
            :class="{ 'error': $v.samples.doctor.$error }"
            class="input LoNotSensitive"
            @input="$v.samples.doctor.$touch()"
            >
            <label
              v-if="$v.samples.doctor.$error && !$v.samples.doctor.required"
              class="error"
              for="doctor"
            >This field is required.</label>
        </div>
      </div>
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-location" />
          <input
            id="address"
            v-model="samples.address"
            type="text"
            name="address"
            placeholder="Address"
            required="required"
            :class="{ 'error': $v.samples.address.$error }"
            class="input LoNotSensitive"
            @input="$v.samples.address.$touch()"
            >
            <label
              v-if="$v.samples.address.$error && !$v.samples.address.required"
              class="error"
              for="address"
            >This field is required.</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-phone" />
          <input
            v-mask="'(###) ###-####'"
            id="phone"
            v-model="samples.phone"
            :class="{ 'error': $v.samples.phone.$error }"
            type="text"
            name="phone"
            placeholder="Phone"
            required="required"
            class="input LoNotSensitive"
            @input="$v.samples.phone.$touch()"
          >
          <label
            v-if="$v.samples.phone.$error && !$v.samples.phone.minLength"
            class="error"
            for="name"
          >Minimal length is 10 numbers.</label>
        </div>
      </div>
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-building" />
          <input
            id="city"
            v-model="samples.city"
            type="text"
            name="city"
            placeholder="City"
            required="required"
            :class="{ 'error': $v.samples.city.$error }"
            class="input LoNotSensitive"
            @input="$v.samples.city.$touch()"
            >
            <label
              v-if="$v.samples.city.$error && !$v.samples.city.required"
              class="error"
              for="doctor"
            >This field is required.</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-fax" />
          <input
            v-mask="'(###) ###-####'"
            id="fax"
            v-model="samples.fax"
            type="text"
            name="fax"
            placeholder="Fax"
            class="input LoNotSensitive"
            @input="$v.samples.fax.$touch()"
          >
        </div>
      </div>
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-shield" />
          <input
            id="state"
            v-model="samples.state"
            type="text"
            name="state"
            placeholder="State"
            required="required"
            :class="{ 'error': $v.samples.state.$error }"
            class="input LoNotSensitive"
            @input="$v.samples.state.$touch()"
            >
            <label
              v-if="$v.samples.state.$error && !$v.samples.state.required"
              class="error"
              for="state"
            >This field is required.</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-certificate" />
          <input
            id="license"
            v-model="samples.license"
            :class="{ 'error': $v.samples.license.$error }"
            type="text"
            name="license"
            placeholder="License No (Required)"
            required="required"
            class="input LoNotSensitive"
            @input="$v.samples.license.$touch()"
          >
          <label
            v-if="$v.samples.license.$error && !$v.samples.license.required"
            class="error"
            for="license"
          >This field is required.</label>
        </div>
      </div>
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-mail" />
          <input
            v-mask="getZipMask(samples.zip)"
            id="zip"
            v-model="samples.zip"
            type="zip"
            name="city"
            placeholder="Zip"
            required="required"
            :class="{ 'error': $v.samples.zip.$error }"
            class="input LoNotSensitive"
            @input="$v.samples.zip.$touch()"
            >
            <label
              v-if="$v.samples.zip.$error && !$v.samples.zip.required"
              class="error"
              for="zip"
            >This field is required.</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="input-wrap">
          <div class="icon icon-star" />
          <input
            id="state"
            v-model="samples.heared"
            :class="{ 'error': $v.samples.heared.$error }"
            type="text"
            name="state"
            placeholder="How Did You Hear About Us? (Required)"
            required="required"
            class="input LoNotSensitive"
            @input="$v.samples.heared.$touch()"
          >
          <label
            v-if="$v.samples.heared.$error && !$v.samples.heared.required"
            class="error"
            for="name"
          >This field is required.</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3 class="h3 title">Please select up to 5 samples.</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="checkbox-wrap">
          <div class="checkbox">
            <input
              v-model="samples.meds.bovine"
              :disabled="!samples.meds.bovine && selectedMedsCount == 5"
              type="checkbox"
              class="LoNotSensitive"
            >
            <div class="icon" />
            <div class="label">{{ $props.simple1 }}</div>
          </div>
          <div class="checkbox">
            <input
              v-model="samples.meds.cisapride_chews"
              :disabled="!samples.meds.cisapride_chews && selectedMedsCount == 5"
              type="checkbox"
              class="LoNotSensitive"
            >
            <div class="icon" />
            <div class="label">{{ $props.simple2 }}</div>
          </div>
          <div class="checkbox">
            <input
              v-model="samples.meds.cisapride_gel"
              :disabled="!samples.meds.cisapride_gel && selectedMedsCount == 5"
              type="checkbox"
              class="LoNotSensitive"
            >
            <div class="icon" />
            <div class="label">{{ $props.simple3 }}</div>
          </div>
          <div class="checkbox">
            <input
              v-model="samples.meds.prednisolone_chews"
              :disabled="!samples.meds.prednisolone_chews && selectedMedsCount == 5"
              type="checkbox"
              class="LoNotSensitive"
            >
            <div class="icon" />
            <div class="label">{{ $props.simple4 }}</div>
          </div>
          <div class="checkbox">
            <input
              v-model="samples.meds.prednisolone_gel"
              :disabled="!samples.meds.prednisolone_gel && selectedMedsCount == 5"
              type="checkbox"
              class="LoNotSensitive"
            >
            <div class="icon" />
            <div class="label">{{ $props.simple5 }}</div>
          </div>
          <div class="checkbox">
            <input
              v-model="samples.meds.metronidazole_chews"
              :disabled="!samples.meds.metronidazole_chews && selectedMedsCount == 5"
              type="checkbox"
              class="LoNotSensitive"
            >
            <div class="icon" />
            <div class="label">{{ $props.simple6 }}</div>
          </div>
          <div class="checkbox">
            <input
              v-model="samples.meds.metronidazole_gel"
              :disabled="!samples.meds.metronidazole_gel && selectedMedsCount == 5"
              type="checkbox"
              class="LoNotSensitive"
            >
            <div class="icon" />
            <div class="label">{{ $props.simple7 }}</div>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="checkbox-wrap">
          <div class="checkbox">
            <input
              v-model="samples.meds.otic"
              :disabled="!samples.meds.otic && selectedMedsCount == 5"
              type="checkbox"
              class="LoNotSensitive"
            >
            <div class="icon" />
            <div class="label">{{ $props.simple8 }}</div>
          </div>
          <div class="checkbox">
            <input
              v-model="samples.meds.methimazole_chews"
              :disabled="!samples.meds.methimazole_chews && selectedMedsCount == 5"
              type="checkbox"
              class="LoNotSensitive"
            >
            <div class="icon" />
            <div class="label">{{ $props.simple9 }}</div>
          </div>
          <div class="checkbox">
            <input
              v-model="samples.meds.methimazole_gel"
              :disabled="!samples.meds.methimazole_gel && selectedMedsCount == 5"
              type="checkbox"
              class="LoNotSensitive"
            >
            <div class="icon" />
            <div class="label">{{ $props.simple10 }}</div>
          </div>
          <div class="checkbox">
            <input
              v-model="samples.meds.kcs"
              :disabled="!samples.meds.kcs && selectedMedsCount == 5"
              type="checkbox"
              class="LoNotSensitive"
            >
            <div class="icon" />
            <div class="label">{{ $props.simple11 }}</div>
          </div>
          <div class="checkbox">
            <input
              v-model="samples.meds.diethylstilbestrol_chews"
              :disabled="!samples.meds.diethylstilbestrol_chews && selectedMedsCount == 5"
              type="checkbox"
              class="LoNotSensitive"
            >
            <div class="icon" />
            <div class="label">{{ $props.simple12 }}</div>
          </div>
          <div class="checkbox">
            <input
              v-model="samples.meds.wound_v_spray"
              :disabled="!samples.meds.wound_v_spray && selectedMedsCount == 5"
              type="checkbox"
              class="LoNotSensitive"
            >
            <div class="icon" />
            <div class="label">{{ $props.simple13 }}</div>
          </div>
          <div class="checkbox">
            <input
              v-model="samples.meds.blank_bcp_vetchew_flavors"
              :disabled="!samples.meds.blank_bcp_vetchew_flavors && selectedMedsCount == 5"
              type="checkbox"
              class="LoNotSensitive"
            >
            <div class="icon" />
            <div class="label">{{ $props.simple14 }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <vue-recaptcha
          ref="recaptcha"
          :load-recaptcha-script="true"
          :sitekey="sitekey"
          size="invisible"
          @verify="submit"
          @expired="onCaptchaExpired"
        />
        <vue-button-spinner
          :is-loading="isLoading"
          :disabled="isLoading"
          :status="status"
          type="submit"
          class="btn wide"
        >
          <span>Send</span>
        </vue-button-spinner>
      </div>
      <div class="col" />
    </div>
    <sweet-modal ref="samples_modal" :blocking="true" :hide-close-button="true">
      <div style="text-align: center;">
        <div class="modal-close-btn cross">
          <span class="icon-cross" />
        </div>
        <div class="modal-body">
          <h2 class="title">Success!</h2>
          <div class="notification-block">
            <p>We have received your request for free samples.<br>We will contact you as soon as possible.</p>
            <div class="button-wrap">
              <button
                class="btn modal-close-btn"
                style="margin: 15px auto 0;"
                @click="confirmModal"
              >Ok</button>
            </div>
          </div>
        </div>
      </div>
    </sweet-modal>
  </form>
</template>

<script>
/* global axios, gtag */
import { required, minLength, email } from 'vuelidate/lib/validators'
import { SweetModal } from 'sweet-modal-vue'
import VueRecaptcha from 'vue-recaptcha'
import ZipMask from './../../mixins/ZipMask'
import ValidateScroll from '../../mixins/ValidateScroll'

export default {
  name: 'FreeSamples',
  components: {
    VueRecaptcha,
    SweetModal
  },
  mixins: [ZipMask, ValidateScroll],
  props: [
    'simple1',
    'simple2',
    'simple3',
    'simple4',
    'simple5',
    'simple6',
    'simple7',
    'simple8',
    'simple9',
    'simple10',
    'simple11',
    'simple12',
    'simple13',
    'simple14'
],
  data: () => {
    return {
      samples: {
        meds: {}
      },
      sitekey: process.env.RECAPTCHA_SITE_KEY,
      isLoading: false,
      status: ''
    }
  },
  validations: {
    samples: {
      email: {
        required,
        email
      },
      phone: {
        minLength: minLength(10)
      },
      // fax: {
      //   minLength: minLength(10)
      // },
      license: {
        required
      },
      heared: {
        required
      },
      patient_first_name: {
          required
      },
      patient_last_name: {
          required
      },
      species: {
        required
      },
      breed: {
        required
      },
      weight: {
        required
      },
      age: {
        required
      },
      sex: {
        required
      },
      clinic: {
        required
      },
      doctor: {
        required
      },
      address: {
        required
      },
      phone: {
        required
      },
      city: {
        required
      },
      state: {
        required
      },
      zip: {
        required
      }
    }
  },
  computed: {
    selectedMedsCount: function () {
      let keys = Object.keys(this.samples.meds)
      keys = keys.filter(item => {
        return this.samples.meds[item]
      })
      return keys.length
    },
    selectedMeds: function () {
      let keys = Object.keys(this.samples.meds)
      keys = keys.filter(item => {
        return this.samples.meds[item]
      })
      return keys
    }
  },
  methods: {
    submit (recaptchaToken) {
      if (!this.$v.$invalid) {
        this.isLoading = true
        let formData = new FormData()
        this.samples.patient = this.samples.patient_first_name + ' ' + this.samples.patient_last_name
        formData.append('type', 'samples')

        for (var key in this.samples) {
          if (key === 'meds') {
            formData.append(key, this.selectedMeds)
          } else {
            formData.append(key, this.samples[key])
          }
        }
        formData.append('recaptcha_token', recaptchaToken)

        axios
          .post('/api/forms/submit', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            if (response && response.data && response.data.result === 'ok') {
              this.$refs.samples_modal.open()
              this.isLoading = false
              if (Object.keys(window).indexOf('gtag') !== -1) {
                gtag('event', 'sent', {
                  event_category: 'form',
                  event_label: 'free-samples',
                  value: 1
                })
              }
            } else {
              console.log(response.data.message)
              this.isLoading = false
            }
          })
          .catch(error => {
            console.log(error)
            this.isLoading = false
          })
      }
    },
    confirmModal () {
      let that = this
      this.$nextTick(() => {
        that.samples = {
          meds: {}
        }
        that.$v.$reset()
        that.$refs.recaptcha.reset()
        that.$refs.samples_modal.close()
      })
    },
    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
    },
    validate () {
      this.validateWithScroll()
      if (!this.$v.$invalid) {
        this.$refs.recaptcha.execute()
      }
    }
  }
}
</script>

<style>
</style>
